import Resy from '../../../images/Resy.png';

export const ResyIcon = () => (
  <div className="order-res-links-icon">
    <img src={Resy} alt="Resy" />
  </div>
);

export default ResyIcon;
